<script>
  import {onDestroy} from 'svelte';
  import {getInstance} from '../../../services/animation';
  import {beta} from '../../beta/beta';
  import editorInstance from '../editor';
  import editorStore from '../editor.store';

  let active = false;
  $: active = $editorStore.active;
  const clickBtn = () => editorStore.activate();
  let previousProgress = 0;
  let previousState = false;
  const animService = getInstance();
  const unmount = editorStore.subscribe(state => {
    if (previousState == state.active) return;
    previousState = state.active;
    if (state.active) {
      previousProgress = animService.progress;
    } else {
      editorInstance.ui.removeHighlight();
      editorStore.setActiveComponent(null);
      // animService.buildAnimations();
      // animService.templateLoader.adjustDisplayForPreview();
    }

    setTimeout(() => {
      animService.templateLoader.adjustDisplayForPreview();
      animService.quickBuildAnimations();
    }, 100);
  });

  onDestroy(unmount);
</script>

<button
  use:beta
  id="advanced-editor-toggle"
  class="flex w-full items-center bg-white transition-all hover:bg-gray-50"
  on:click={clickBtn}
>
  <span
    class="editor-label pl-4 text-left text-xs uppercase transition-all {active
      ? 'font-bold text-primary-600'
      : 'text-gray-500'}"
  >
    {!active ? 'Go to advanced editor mode' : 'Advanced Editor Mode'}</span
  >
  <span
    class="verySmallText ml-2 rounded-lg border border-gray-50 bg-gradient-to-t from-primary to-primary-600 px-2 py-1 font-bold text-white"
    >BETA</span
  >
  <div
    class="icon ml-auto flex h-full items-center justify-center border-l border-gray-100 px-6 text-center text-primary-600 transition-all"
  >
    <i class={!active ? 'gg-chevron-right' : 'gg-close-o'} />
  </div>
</button>

<style lang="postcss">
  .verySmallText {
    font-size: 0.5rem;
  }
  #advanced-editor-toggle {
    height: 65px;
  }
  #advanced-editor-toggle:hover .icon {
    @apply bg-primary text-white;
  }
  /* #advanced-editor-toggle:hover .editor-label {
    @apply text-primary;
  } */
</style>
